import { render, staticRenderFns } from "./buyRecord.vue?vue&type=template&id=7b9bff4c&scoped=true"
import script from "./buyRecord.vue?vue&type=script&lang=ts"
export * from "./buyRecord.vue?vue&type=script&lang=ts"
import style0 from "./buyRecord.vue?vue&type=style&index=0&id=7b9bff4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9bff4c",
  null
  
)

export default component.exports